import React, { useEffect, useState } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import InputComponent from "../InputComponent";
import { showToast } from "../../../patient/utils/toastUtils";
import { getValueFromPatToken } from "../../../patient/utils/commonUtils";
import { getValueFromToken } from "../../utils/tokenUtils";
import "react-datepicker/dist/react-datepicker.css";
import { Formik, Form, useFormik } from "formik";
import { changePasswordValidationSchema, passwordValidationSchema } from "../../utils/validations/registrationValidation";
import { FaSpinner } from "react-icons/fa";
import { changePassword } from "../../services/authApi";

const ChangePasswordSection = ({
  collapsed,
  toggleSection,
  callType
}) => {

    const [loading, setLoading] = useState(false);

    const passwordFormik = useFormik({
        initialValues: {
            oldPassword: "",
            password: "",
            confirmPassword: "",
        },
        validationSchema: changePasswordValidationSchema,
        onSubmit: async (values) => {
            setLoading(true);
            const { status, message } = await changePassword({oldPassword: values.oldPassword, password: values.password});
            if (status) {
                setLoading(false);
                showToast(message, "success");
                passwordFormik.resetForm();
            } else {
                setLoading(false);
                showToast(message, "error");
            }
        },
    });

    return (
        <div className="section">
            <div className="section-header flex justify-between items-center pb-3 border-b border-gray-200 text-gray-900 text-lg pt-3 font-medium px-5">
                <div className="text-left">Change Password</div>
                    <button onClick={() => toggleSection("changePassword")}>
                        {collapsed ? <FiPlus /> : <FiMinus />}
                    </button>
            </div>
            {!collapsed && (
                <div className="section-content px-5 py-12 border-b border-gray-200">
                    <div className="w-full flex flex-wrap mx-1">
                        <Formik
                            initialValues={passwordFormik.initialValues}
                            validationSchema={changePasswordValidationSchema}
                            onSubmit={passwordFormik.handleSubmit}
                        >
                            {({ errors, touched }) => (
                                <Form className="w-full">
                                    <div className="flex w-full gap-5">
                                        <InputComponent
                                            label="Old Password"
                                            id="oldPassword"
                                            type="password"
                                            className="mb-5 w-full"
                                            value={passwordFormik.values.oldPassword}
                                            onChange={passwordFormik.handleChange}
                                            error={passwordFormik.errors.oldPassword}
                                        />
                                        <InputComponent
                                            label="New Password"
                                            id="password"
                                            type="password"
                                            className="mb-5 w-full"
                                            value={passwordFormik.values.password}
                                            onChange={passwordFormik.handleChange}
                                            error={passwordFormik.errors.password}
                                        />
                                        <InputComponent
                                            label="Confirm Password"
                                            id="confirmPassword"
                                            type="password"
                                            className="mb-5 w-full"
                                            value={passwordFormik.values.confirmPassword}
                                            onChange={passwordFormik.handleChange}
                                            error={passwordFormik.errors.confirmPassword}
                                        />
                                    </div>
                                    <button
                                        type="submit"
                                        onClick={passwordFormik.handleSubmit}
                                        className="min-w-[131px] text-base font-medium rounded-lg py-2 px-5  bg-[#2E37A4] hover:bg-[#1a238f] text-white flex justify-center"
                                        disabled={loading}
                                    >
                                        {loading ? (<FaSpinner size={20} className="animate-spin" />) : ("Reset Password")}
                                    </button>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChangePasswordSection;
